<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <core-card [actions]="[]">
        <div class="card-title w-100">
          <div class="row">
            <div class="col-xl-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="searchOrder(); changeQueryParams()" />
            </div>
            <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <ng-select [(ngModel)]="filter_customer" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchOrder(); changeQueryParams()">
                <ng-option [value]="0">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "CUSTOMER" | translate }}</span>
                </ng-option>
                <ng-option [value]="customer.id" *ngFor="let customer of customersList">
                  <span class="font-small-4 font-weight-normal pr-2">{{ customer.name }}</span>
                </ng-option>
              </ng-select>
            </div>
            <div class="col-xl-2 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <ng-select [(ngModel)]="filter_status_round" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchOrder(); changeQueryParams()">
                <ng-option [value]="-1">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "STATE_ROUND" | translate }}</span>
                </ng-option>
                <ng-option [value]="0">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "NOT_STARTED" | translate }}</span>
                </ng-option>
                <ng-option [value]="1">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "ACTIVATED_MASCULIN" | translate }}</span>
                </ng-option>
                <ng-option [value]="2">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "EXPIRED" | translate }}</span>
                </ng-option>
                <ng-option [value]="3">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "CLOSE_MASCULIN" | translate }}</span>
                </ng-option>
              </ng-select>
            </div>
            <div class="col-xl-5 text-right" [ngClass.sm]="'col-12 mt-1'">
              <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" *ngIf="_utilService.isDesktop">
                <label class="d-flex align-items-center"
                  >{{ "SHOW" | translate }}
                  <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
              <span (click)="modalOpen(chooseCommission)" class="btn btn-outline-primary" *ngIf="this._authenticationService.hasCapability('create_order')">{{ "ADD" | translate }}</span>
            </div>
          </div>
        </div>

        <!--desktop-->
        <div class="card-body px-0 pb-0" *ngIf="_utilService.isDesktop">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="60"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filterOrders"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          >
            <ngx-datatable-column [name]="'CUSTOMER' | translate" prop="commission.client.name">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <img #image (error)="image.hidden = true" src="{{ row.commission.client.logo }}" class="mr-1" [alt]="row.commission.client.name" width="32" height="32" />
                  <div class="avatar bg-light-secondary mr-1 ml-0" *ngIf="image.hidden">
                    <div class="avatar-content text-uppercase">{{ row.commission.client.business_name[0] }}</div>
                  </div>
                  <a class="text-break-line-1" routerLink="/dashboard/customer/edit/{{ row?.commission?.client?.id }}" [ngbTooltip]="row?.commission?.client?.name">{{ row?.commission?.client?.name }}</a>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'DEAL_ORDER' | translate" prop="commission.protocol">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <a routerLink="/dashboard/commission/edit/{{ row?.commission?.id }}">{{ row?.commission.protocol }}</a>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'FROM' | translate" prop="from">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.from ? _utilService.formatDate(row.from) : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TO' | translate" prop="to">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.to ? _utilService.formatDate(row.to) : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CAPACITY' | translate" prop="capacity">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.capacity_formatted ? row.capacity_formatted + " €" : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'RESIDUE' | translate" prop="residue">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.residue_formatted ? row.residue_formatted + " €" : "-" }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'STATE' | translate" prop="label">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span class="badge badge-pill badge-{{ row.status_color }}">
                  {{ row.label }}
                </span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex">
                  <button class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_order')">
                    <a [routerLink]="'/dashboard/commission/edit/' + row.commission_id" [queryParams]="{ order_id: row.id }" class="text-secondary text-center" [ngbTooltip]="'VIEW' | translate" placement="left">
                      <i [data-feather]="'eye'" size="19"></i>
                    </a>
                  </button>
                  <button class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_order')">
                    <a [routerLink]="'/dashboard/commission/edit/' + row.commission_id" [queryParams]="{ order_id: row.id }" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left">
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </a>
                  </button>
                  <button class="bg-transparent border-0 text-secondary" *ngIf="_authenticationService.hasCapability('delete_order')">
                    <span (click)="deleteOrder(row)" class="text-danger text-center" [ngbTooltip]="'DELETE' | translate" placement="left">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </span>
                  </button>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>

        <!--mobile-->
        <div class="card-body px-0 pb-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="250"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filterOrders"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          >
            <ngx-datatable-column [name]="'CUSTOMER' | translate" prop="commission.client.name">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row">
                  <div class="col-12">
                    <!--nome-->
                    <div class="d-flex align-items-center">
                      <img #image (error)="image.hidden = true" src="{{ row.commission.client.logo }}" class="mr-1" [alt]="row.commission.client.name" width="32" height="32" />
                      <div class="avatar bg-light-secondary mr-1 ml-0" *ngIf="image.hidden">
                        <div class="avatar-content text-uppercase">{{ row.commission.client.business_name[0] }}</div>
                      </div>
                      <a routerLink="/dashboard/customer/edit/{{ row?.commission?.client?.id }}">{{ row?.commission?.client?.name }}</a>
                    </div>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "DEAL_ORDER" | translate }}: </span>
                    <a routerLink="/dashboard/commission/edit/{{ row?.commission?.id }}">{{ row?.commission.protocol }}</a>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "FROM" | translate }}: </span>
                    <span>{{ row.from ? _utilService.formatDate(row.from) : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "TO" | translate }}: </span>
                    <span>{{ row.to ? _utilService.formatDate(row.to) : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "CAPACITY" | translate }}: </span>
                    <span>{{ row.capacity_formatted ? row.capacity_formatted + " €" : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "RESIDUE" | translate }}: </span>
                    <span>{{ row.residue_formatted ? row.residue_formatted + " €" : "-" }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "STATE" | translate }}: </span>
                    <span class="badge badge-pill badge-{{ row.status_color }}">{{ row.label }}</span>
                  </div>
                  <div class="col-12 d-flex justify-content-end">
                    <button class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_order')">
                      <a [routerLink]="'/dashboard/commission/edit/' + row.commission_id" [queryParams]="{ order_id: row.id }" class="text-secondary text-center" [ngbTooltip]="'VIEW' | translate" placement="left">
                        <i [data-feather]="'eye'" size="19"></i>
                      </a>
                    </button>
                    <button class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_order')">
                      <a [routerLink]="'/dashboard/commission/edit/' + row.commission_id" [queryParams]="{ order_id: row.id }" class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left">
                        <i [data-feather]="'edit-2'" size="19"></i>
                      </a>
                    </button>
                    <button class="bg-transparent border-0 text-secondary" *ngIf="_authenticationService.hasCapability('delete_order')">
                      <span (click)="deleteOrder(row)" class="text-danger text-center" [ngbTooltip]="'DELETE' | translate" placement="left">
                        <i [data-feather]="'trash-2'" size="19"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </core-card>
    </section>
  </div>
</div>

<!-- note choose Commission Modal -->
<ng-template #chooseCommission let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "SELECT_COMMISSION" | translate }}</h3>
      <div class="form-group mb-1">
        <label for="commission">{{ "DEAL_ORDER" | translate }}<sup class="text-danger">*</sup></label>
        <ng-select
          id="commission"
          bindLabel="protocol"
          bindValue="id"
          [(ngModel)]="selectedCommissionID"
          [multiple]="false"
          [searchable]="true"
          [closeOnSelect]="true"
          [ngModelOptions]="{ standalone: true }"
          [clearable]="false"
          [openOnEnter]="false"
          [virtualScroll]="true"
          [items]="commissionList"
        ></ng-select>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button class="btn btn-outline-primary" (click)="modalClose()">{{ "BACK" | translate }}</button>
      <button [disabled]="!selectedCommissionID" (click)="createOrder()" class="btn btn-primary w-150" rippleEffect>
        {{ "ADD_ROUND" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / note choose Commission Modal -->
